
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: ["banner-icons",classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"87","height":"87","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M8.582 18.593s20.456 32.185 47.904 29.201c15.093-1.64 23.296 16.734 23.296 16.734l-71.2.984v-46.92z","fill":"#87A6D5"}}),_c('path',{attrs:{"d":"M77.813 21.218v40.685a2.633 2.633 0 01-2.625 2.625H12.191a2.633 2.633 0 01-2.625-2.625V21.218a2.633 2.633 0 012.625-2.625h62.997a2.633 2.633 0 012.625 2.625zm-43.31 45.935h18.374v6.562H34.502v-6.562zm45.935-5.184V21.217c0-2.887-2.363-5.25-5.25-5.25H12.191c-2.887 0-5.25 2.363-5.25 5.25V61.97c.066 2.887 2.363 5.184 5.25 5.184h19.687v6.562h-6.563v2.625h36.749v-2.625H55.5v-6.562h19.687c2.887 0 5.184-2.297 5.25-5.184z","fill":"#1B3067"}}),_c('path',{attrs:{"stroke":"#1B3067","stroke-width":"3","d":"M57.758 27.331h8.836v8.836h-8.836zM57.758 42.454h8.836v8.836h-8.836zM43.949 42.454h8.836v8.836h-8.836zM19.621 27.331h19.356V51.29H19.621zM43.949 27.331h8.836v8.836h-8.836zM67.438 58.235H18.122"}})])
          )
        }
      }
    